import "bootstrap/dist/css/bootstrap.min.css";
import { addLocale, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import apis from '../../api';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { LabelField } from './Overtime.styles';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import Video from '../Video/Video';
import { tableDate, timeToDate } from "../../services/tableDate.service";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import useWindowDimensions from '../hooks/useDimensions';
import "./Overtime.css"
import useParamsOvertime from "../../helpers/useParamsOvertime";
import { FileUpload } from "primereact/fileupload";
import { saveAs } from 'file-saver';
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { excelReport } from "../../services/excelReport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Overtime
Description : Creación de horas extras de un empleado.
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a las modificaciones realizadas con PrimeReact
================================================================================ */


export default function Overtime() {

  /*Listas de valores del componente*/
  const [listaHorasExtra, setListaHorasExtra] = useState([]);
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);
  const [listasCargadas, setListasCargadas] = useState(false)

  /*Propiedades del componente*/
  const [codEmpleado, setCodEmpleado] = useState("");
  const [concepto, setConcepto] = useState("");
  const [tiempo, setTiempo] = useState(0);
  const [calendario, setCalendario] = useState("");
  const [idOcasional, setIdOcasional] = useState("");
  const [fechaNovedad, setFechaNovedad] = useState("");

  const [rowId, setRowId] = useState(0);

  const [historico, setHistorico] = useState([])
  const [params] = useParamsOvertime();

  /*Propiedades de los modales del componente*/
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenH, setIsOpenH] = React.useState(false);
  const [isOpenNovelties, setIsOpenNovelties] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loadPage, setLoadPage] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [consultado, setConsultado] = useState(false);

  /*Constantes globales para el componente*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const { width } = useWindowDimensions()

  /*Formato para el calendario del componente*/
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  useEffect(() => {
    /*Se cargan los datos de las listas de valores del componente*/
    setTabla();
  }, [rowId]);

  useEffect(() => {
    /*Se inicializan las propiedades del componente para la generación de reportes*/
    const historicTemplate = async () => {
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setHistorico(plantilla)
    }
    historicTemplate()
  }, [params]);

  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
        <Button label="Reporte histórico" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm" onClick={() => showModalH()} />
        <Button type="button" icon="pi pi-upload" label="Cargar novedades" tooltip='Proceso cargue masivo recargos y horas extra'
          className="p-button-success mr-2 p-button-sm" onClick={() => showModalNovelties()} tooltipOptions={{ position: 'top' }} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Actualizar horas extra" tooltipOptions={{ position: 'top' }} onClick={() => { setIdOcasional(rowData["ID"]); initializeData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar horas extra" tooltipOptions={{ position: 'top' }} onClick={() => { setIdOcasional(rowData["ID"]); showModalEliminar() }} />
      </div>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="barra">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'UNIT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CALENDAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  /*Funciones que manejan el comportamiento de los modales del componente*/
  const showModal = () => {
    if (!listasCargadas) {
      setListas()
    }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
    limpiar();
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalH = () => {
    setIsOpenH(true);
  };

  const hideModalH = () => {
    setIsOpenH(false);
  };

  const showModalNovelties = () => {
    setIsOpenNovelties(true);
  };

  const hideModalNovelties = () => {
    setIsOpenNovelties(false);
  };

  async function limpiar() {
    setCodEmpleado("");
    setConcepto("");
    setTiempo("");
    setIdOcasional("");
    setCalendario("");
    setFechaNovedad("");
  }

  const GetCalendar = async (contract = "") => {
    await apis.getNoveltiesCalendar(contract, headers).then(res => {
      let lista = res.data["CALENDAR"]
      let contenidoCalendario = []
      lista.forEach(element => {
        contenidoCalendario.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
      })
      setListaCalendario(contenidoCalendario)

    })
  }

  async function setListas() {

    GetCalendar()

    await apis.getOvertimeLists(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let codsEmpleados = res.data["CONTRACTS"]
      let horasExtra = res.data["CONCEPTS"]
      let contenidoHorasExtra = []
      let contenidoCodEmpleado = []
      codsEmpleados.forEach(element => {
        contenidoCodEmpleado.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
      })
      horasExtra.forEach(element => {
        contenidoHorasExtra.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
      })
      setListaHorasExtra(contenidoHorasExtra);
      setListaCodEmpleado(contenidoCodEmpleado);
      setListasCargadas(true)
    })

  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    await apis.getOvertime(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["NOVELTIES"].length > 0) {
        let data = res.data["NOVELTIES"]
        let contenidoTabla = []
        data.forEach(element => {
          let concepto = element["CONCEPT_ID"].split("|")
          let datos = element["NAME"].split("|")
          let calendario = element["ID_CALENDAR"].split("|")
          let fecha = tableDate(element.DATE_NOVELTY)
          contenidoTabla.push({
            ID: element.OCCASIONAL_ID, CONTRACT_ID: element.CONTRACT_ID, NUMBER_ID: datos[0], NAME: datos[1], CONCEPT: concepto[1],
            UNIT: element.UNIT, CALENDAR_ID: calendario[0], CALENDAR: calendario[1], DATE_NOVELTY: element.DATE_NOVELTY,
            DATE_NOVELTY: fecha, FORMAT_DATE_NOVELTY: invDateFormat(element.DATE_NOVELTY)
          })
        })
        setRows(contenidoTabla)
        setRowData(contenidoTabla)
        setLoadPage(true)
      }
      else {
        setRows([])
        setRowData([])
        setLoadPage(true)
      }
    })
  }

  async function postOvertimes() {
    /*Función encargada de guardar la hora extra en la base de datos*/
    let empleado = codEmpleado.split("|")

    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _codEmpleado = empleado[0];
    const _concepto = concepto.value;
    const _tiempo = tiempo;
    const _calendario = calendario.value;
    const _fechaNovedad = dateFormat(fechaNovedad);

    const overtime = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      CONTRACT_ID: _codEmpleado,
      CONCEPT_ID: _concepto,
      UNIT: _tiempo,
      DATE_NOVELTY: _fechaNovedad
    }

    try {
      await apis.postOvertime(overtime, headers).then(res => {
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Horas extra agregadas exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal();
    } catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function putOvertimes() {
    /*Función encargada de actualizar la hora extra en la base de datos*/
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _idOcasional = idOcasional
    const _tiempo = tiempo;
    const _calendario = calendario;
    const _fechaNovedad = dateFormat(fechaNovedad);

    const overtime = {
      CLIENT: _cliente,
      ENTITY: _entity,
      OCCASIONAL_ID: _idOcasional,
      ID_CALENDAR: _calendario,
      UNIT: _tiempo,
      DATE_NOVELTY: _fechaNovedad
    }

    console.log(overtime)

    try {
      await apis.putOvertime(overtime, headers).then(res => {
        setLoading2(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Horas extra actualizadas exitosamente' });
      })

      setTabla();
      limpiar();
      hideModal_();
    } catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function deleteOvertimes() {

    /*Función de eliminar la hora extra de la base de datos*/
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _idOcasional = idOcasional;

    try {
      await apis.deleteOvertime(_entity, _cliente, _idOcasional, headers).then(res => {
        setLoading3(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Horas extra eliminadas exitosamente' });
      })

      setTabla();
      limpiar();
      hideModalEliminar();
    } catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  async function postOvertimeReport() {

    /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    historico.forEach(h => {
      let size = h.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    historico.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.overtimeReport(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, 'reporteHEyRecargos')
        setLoading4(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de novedades reportadas generado existosamente" });
        hideModalH();
      })
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function initializeData(rowData) {
    /*Función encargada de inicializar las propiedades del componente con los valores de la hora extra seleccionada*/
    setIdOcasional(rowData.ID);
    setCodEmpleado(rowData.CONTRACT_ID);
    setConcepto(rowData.CONCEPT);
    setCalendario(rowData.CALENDAR_ID)
    setTiempo(rowData.UNIT);
    setFechaNovedad(rowData.FORMAT_DATE_NOVELTY);
    showModal_();
  }

  const dateTemplate = (rowData) => {
    const date = timeToDate(rowData.DATE_NOVELTY);
    return date
  }

  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadAccumulated",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.importOvertime(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading5(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading5(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.importOvertime(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importNovelties(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadAccumulated",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  /*Headers y footers de los modales del componente*/
  const addFooter = (
    <div>
      <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postOvertimes() }} />
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar horas extra</h3>
    </div>
  )

  const updateFooter = (
    <div>
      <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
      <Button label='Guardar' loading={loading2} onClick={() => { setLoading2(true); putOvertimes() }} />
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar horas extra</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading3(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); deleteOvertimes() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar las horas extra?</h3>
    </div>
  )

  const footerHS = (
    <div>
      <Button label='Generar' loading={loading4} onClick={() => { setLoading4(true); postOvertimeReport() }} />
    </div>
  );

  const headerHS = (
    <div>
      <h3>Parámetros reporte novedades de horas extra y recargos</h3>
    </div>
  )

  /*Header y footers de los modales del componente*/
  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); setLoading6(false); hideModalNovelties() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importNovelties}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar recargos y horas extra</h3>
    </div>
  )

  /*Funciones que manejan el cambio en los campos de entrada del modal de generación del reporte*/
  function handleChangeH(e, d, index) {
    setHistorico(h => {
      let newHistorico = [...h]
      console.log(index)
      console.log(h)
      newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeDateH(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeTextH(e, d, index) {
    console.log(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  /*Renderizado del componente*/
  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Código empleado</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={codEmpleado} options={listaCodEmpleado} placeholder={"Seleccione un Empleado"}
            onChange={(e) => { setCodEmpleado(e.value); GetCalendar(e.value) }} />
          <LabelField htmlFor="label">Calendario</LabelField>
          <Dropdown style={elementWidth} value={calendario.value} autoFocus
            filter showClear filterBy="label" emptyMessage={"No hay calendarios disponibles"}
            options={listaCalendario} placeholder={"Seleccione calendario"} disabled={!codEmpleado}
            onChange={(e) => {
              let label = e.originalEvent.nativeEvent.target.textContent;
              setCalendario({ "value": e.value, "label": label })
            }}
          />
          <LabelField htmlFor="label">Concepto</LabelField>
          <Dropdown style={elementWidth} value={concepto.value}
            filter showClear filterBy="label" emptyMessage={"No hay conceptos disponibles"}
            options={listaHorasExtra} placeholder={"Seleccione concepto"} disabled={!codEmpleado}
            onChange={(e) => {
              let label = e.originalEvent.nativeEvent.target.textContent;
              setConcepto({ "value": e.value, "label": label })
            }}
          />
          <LabelField htmlFor="label">Tiempo</LabelField>
          <InputNumber
            style={elementWidth}
            id="label2"
            placeholder="Tiempo"
            value={tiempo}
            maxFractionDigits={2}
            disabled={!codEmpleado}
            onChange={(e) => setTiempo(e.value)}
          />
          <LabelField htmlFor="label">Fecha novedad</LabelField>
          <Calendar style={elementWidth} id="navigators" value={fechaNovedad}
            onChange={(e) => setFechaNovedad(e.value)} disabled={!codEmpleado}
            locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaNovedad}
            yearRange="2010:2030"
          />
        </Dialog>
        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Tiempo</LabelField>
          <InputNumber
            style={elementWidth}
            id="label2"
            autoFocus
            value={tiempo}
            maxFractionDigits={2}
            placeholder="Tiempo"
            onChange={(e) => setTiempo(e.value)}
          />
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <Dialog header={headerHS} footer={footerHS} visible={isOpenH} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalH}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={historico[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME"
                      emptyMessage={"No hay " + label + "s disponibles"}
                      //optionTemplate={optionTemplate}
                      placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChangeH(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Calendar key={d} style={elementWidth} id="navigators" value={historico[index].CODE}
                      onChange={(e) => handleChangeDateH(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historico[index].CODE}
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={historico[index]}
                      onChange={(e) => handleChangeTextH(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Horas extra y recargos</span>
          <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESOVERTIME_VIDEO')} />
        </div>
        <Dialog header={header} footer={footer} visible={isOpenNovelties}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalNovelties}>
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja UploadNov_time, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog>
        <ConfBar style={{ marginTop: "-2rem" }} />
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'CONCEPT', 'UNIT', 'CALENDAR']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="CONCEPT" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
              <Column field="UNIT" header="Tiempo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
              <Column field="CALENDAR" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column field="DATE_NOVELTY" body={dateTemplate} header="Fecha novedad" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha novedad" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}